import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { AddressComponent } from '../../common-components/address/address.component';
import { CreateAccountsComponent } from './create-accounts/create-accounts.component';
import { GlobalAdminComponent } from './global-admin/global-admin.component';
import { LoginAuditsComponent } from './login-audits/login-audits.component';
import { LoginAudit } from './model/login-audit';
import { PermissionsComponent } from './permissions/permissions.component';
import { RolesComponent } from './roles/roles.component';
import { SearchAccountsComponent } from './search-accounts/search-accounts.component';

const routes: Routes = [
    {
        path: 'search',
        component: SearchAccountsComponent,
        canActivate: [AuthGuard] // RouteGuardService
    },
    {
        path: 'create',
        component: CreateAccountsComponent,
        canActivate: [AuthGuard] // , RouteGuardService
    },
    {
        path: 'login-audits',
        component: LoginAuditsComponent,
        canActivate: [AuthGuard] //, RouteGuardService
    },
    {
        path: 'roles',
        component: RolesComponent,
        canActivate: [AuthGuard] // , RouteGuardService
    },
    {
        path: 'permissions',
        component: PermissionsComponent,
        canActivate: [AuthGuard] // , RouteGuardService
    },
    {
        path: 'global-admin',
        component: GlobalAdminComponent,
        canActivate: [AuthGuard] // , RouteGuardService
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AccountsRoutingModule {}
